import { useState } from "react"
import { Link } from "react-router-dom"
import { useNavigate } from "react-router-dom"

function Login(props) {
    var users = props.users
    const navigate = useNavigate()
    const[ruser,setRuser] = useState(true)
    const[eusername,setEusername] = useState("")
    const[epassword,setEpassword] = useState("")
    function handleuser(e){
        setEusername(e.target.value)
    }
    function handlepassword(e){
        setEpassword(e.target.value)
    }
    function Checkuser(){
        var userfound = false
        users.forEach(function(items){
            if(items.username === eusername && items.password === epassword){
                userfound = true
                navigate("/landing",{state:{username:eusername}})
            }
           
        })
        if(userfound === false){
            setRuser(false)
            setEusername("")
            setEpassword("")
            
        }

    }
    return (<div className="bg-black px-10 py-20">
        <div className="bg-white p-10 border rounded-md">
            <h1 className="text-3xl font-medium">Hey Hi 👋</h1>
            {ruser?<p>I help you manage your activities after you login :)</p>:<p className="text-red-600">Please signup before Login !!</p>}
            <input className="border border-black rounded-md p-1 my-2" type="text" placeholder="username" onChange={handleuser} value={eusername}/><br/>
            <input className="border border-black rounded-md p-1 my-1" type="password" placeholder="password" onChange={handlepassword} value={epassword}/><br/>
            <button className="bg-[#8271DD] px-5 py-2 my-1 border rounded-md" onClick={Checkuser}>Login</button>
            <p>Don't have an account ? <Link to={"/signup"} className="text-blue-700 hover:underline">Signup</Link></p>
        </div>
    </div>)
}
export default Login